import { useEffect, useState } from "react";
import type { LegalPageSlug } from "@calega/content";
import { api } from "../lib/api";
import type { LegalPage } from "../lib/types";
import { ContentBlocks } from "./ContentBlocks";

export function LegalPageView({ slug, onBack }: { slug: LegalPageSlug; onBack: () => void }) {
  const [page, setPage] = useState<LegalPage | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setPage(null);
    setError("");
    api<LegalPage>(`/legal-pages/${slug}`)
      .then(setPage)
      .catch((caught) => setError(caught instanceof Error ? caught.message : "Die Seite konnte nicht geladen werden."));
  }, [slug]);

  if (error) return <div className="alert error">{error}</div>;
  if (!page) return <div className="loading-card">Rechtstext wird geladen …</div>;

  return (
    <article className="content-card legal-page-card">
      <header className="content-heading">
        <img className="content-mascot" src="/brand/lepi-erklaerend.webp" alt="" />
        <span className="page-kind learning">Rechtliches</span>
        <h1>{page.title}</h1>
        <button className="secondary small legal-back" type="button" onClick={onBack}>Zurück</button>
      </header>
      <ContentBlocks blocks={page.blocks} />
      <footer className="version-note">
        <span>Zuletzt aktualisiert am {new Date(page.updatedAt).toLocaleDateString("de-DE")}</span>
      </footer>
    </article>
  );
}
